import React, { useState } from "react";
import { Box, CardActionArea, Collapse, Paper, Stack, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { Conversation } from "@/src/types/Entities/Messaging/Conversation";
import { splitUpByCompletedStatus } from "@/src/services/serviceWorldService";
import MessageCenterNoCasesMessage from "./MessageCenterNoCasesMessage";
import MessageCase from "./MessageCase";

type MessageCenterProps = {
  minimalCases: MinimalCase[];
  conversations: Conversation[];
};

export default function MessageCenter({ minimalCases, conversations }: MessageCenterProps) {
  const [expandClosedCases, setExpandClosedCases] = useState(true);
  const { cases, closedCases } = splitUpByCompletedStatus(minimalCases);

  return (
    <>
      <Box sx={{ marginBottom: "2rem" }}>
        <Typography component={"h1"} variant={"h5"}>
          Nachrichten
        </Typography>
        <Typography>Hier finden Sie eine Übersicht aller Nachrichten zu Ihren Fällen.</Typography>
      </Box>

      {minimalCases.length === 0 ? (
        <MessageCenterNoCasesMessage />
      ) : (
        <Stack spacing={2}>
          {cases.map((minimalCase) => (
            <MessageCase key={minimalCase.id} minimalCase={minimalCase} conversations={conversations} />
          ))}

          {closedCases.length > 0 && (
            <>
              <Paper elevation={4}>
                <CardActionArea onClick={() => setExpandClosedCases((expanded) => !expanded)} sx={{ padding: "1.5rem" }}>
                  <Stack direction={"row"} sx={{ justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant={"h7"}>Abgeschlossene Fälle</Typography>
                    {expandClosedCases ? <ExpandLess /> : <ExpandMore />}
                  </Stack>
                </CardActionArea>
              </Paper>
              <Collapse in={expandClosedCases}>
                <Stack spacing={2}>
                  {closedCases.map((minimalCase) => (
                    <MessageCase key={minimalCase.id} minimalCase={minimalCase} conversations={conversations} />
                  ))}
                </Stack>
              </Collapse>
            </>
          )}
        </Stack>
      )}
    </>
  );
}
